




































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import InputTextComponent from "@/components/common/parts/InputTextComponent.vue";
import ButtonComponent from "@/components/common/parts/ButtonComponent.vue";

@Component({
  components: {
    InputTextComponent,
    ButtonComponent
  }
})
export default class ExchangeDialogComponent extends Vue {
  inputGateway: string = "";

  @Prop({
    default: false
  })
  public display!: boolean;

  @Prop({
    default: ""
  })
  public title!: string;

  @Prop({
    default: ""
  })
  public gatewayInfo!: string;

  @Emit()
  changeInputGatewayInfo(value: string): string {
    return value;
  }

  get holderStyle() {
    return {
      display: this.display ? "flex" : "none"
    };
  }
}
